import { reactive, toRefs } from "vue";

const state = reactive({
  visible: false
});

export function useImprintPopup() {
  return {
    ...toRefs(state),
    showImprint() {
      state.visible = true;
    },
    hideImprint() {
      state.visible = false;
    }
  };
}
